export default "__VITE_ASSET__Dvk0AAm1__"